import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type OrderTagState = readonly string[];

export const ORDER_TAG = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderTagState>>,
): ConditionType<OrderTagState, Condition.OrderTag> => ({
  name: "Order tags",
  description(state) {
    return `Order tags: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<OrderTagState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.OrderTag) {
    return model.tags;
  },
  toModel(state) {
    return { type: Condition.ORDER_TAG, tags: state };
  },
  valid() {
    return true;
  },
});
